import { use } from "react";

import { UserContext } from "@/contexts/user-context";

import type { EditorMediaType } from "./constants";
import { useEditorFieldContext } from "./editor-context";
import {
  addFilesToEditorMediaField,
  type EditorUploadLimit,
} from "./editor-upload-utils";

export const useEditorUpload = () => {
  const { value, setEditorValue } = useEditorFieldContext<"media">();
  const { currentUserPublicKey } = use(UserContext);

  const addFiles = async (
    files: File[],
    type: EditorMediaType,
    limit: EditorUploadLimit = {},
  ) => {
    await addFilesToEditorMediaField({
      files,
      type,
      limit,
      value,
      setEditorValue,
      currentUserPublicKey,
    });
  };

  return {
    addFiles,
  };
};
